namespace RioERP.Web.Enums {
    export enum ShippingStatus {
        Self = 1,
        PartiallyShipped = 2,
        Returned = 3,
        Delivered = 4,
        ReShipped = 5,
        ShipLater = 6,
        Booked = 7
    }
    Serenity.Decorators.registerEnumType(ShippingStatus, 'RioERP.Web.Enums.ShippingStatus');
}
